export default {
  // Navigation
  'nav.home': 'Home',
  'nav.product': 'Product',
  'nav.cases': 'Success Cases',
  'nav.findDoctor': 'Parent Guide',
  'nav.about': 'About Us',
  'nav.doctorLogin': 'Doctor Login',
  
  // Common
  'common.learnMore': 'Learn More',
  'common.contactUs': 'Contact Us',
  'common.submit': 'Submit',
  'common.search': 'Search',
  
  // Footer
  'footer.quickLinks': 'Quick Links',
  'footer.contact': 'Contact Us',
  'footer.followUs': 'Follow Us',
  'footer.copyright': '© 2024 Mirókids. All rights reserved.',
  'footer.phone': 'Phone',
  'footer.email': 'Email',
  'footer.address': 'Address',
};
